<script setup>
// ContactDetailSkeleton.vue — skeleton placeholder enquanto o contato
// e seus sub-recursos (notas, conversas, atributos) carregam.
//
// Reproduz a estrutura do hero + tabs + body pra evitar layout shift.
</script>

<template>
  <div class="flex flex-col flex-1 h-full bg-n-background animate-pulse">
    <!-- Hero skeleton -->
    <div class="border-b border-n-weak px-6 py-4">
      <div class="flex items-start justify-between gap-4">
        <div class="flex items-start gap-4 flex-1 min-w-0">
          <div class="size-16 rounded-full bg-n-alpha-2 shrink-0" />
          <div class="flex flex-col gap-2 flex-1 min-w-0">
            <div class="h-5 w-48 rounded bg-n-alpha-2" />
            <div class="h-4 w-64 rounded bg-n-alpha-2" />
            <div class="h-3 w-32 rounded bg-n-alpha-2" />
          </div>
        </div>
        <div class="flex items-center gap-2 shrink-0">
          <div class="h-8 w-24 rounded-lg bg-n-alpha-2" />
          <div class="h-8 w-28 rounded-lg bg-n-alpha-2" />
          <div class="h-8 w-32 rounded-lg bg-n-alpha-2" />
        </div>
      </div>
      <div class="flex items-center gap-3 mt-3">
        <div class="h-4 w-16 rounded bg-n-alpha-2" />
        <div class="h-4 w-24 rounded bg-n-alpha-2" />
        <div class="h-4 w-20 rounded bg-n-alpha-2" />
      </div>
    </div>

    <!-- Tabs skeleton -->
    <div class="flex items-center gap-2 px-6 border-b border-n-weak h-11">
      <div class="h-6 w-24 rounded bg-n-alpha-2" />
      <div class="h-6 w-20 rounded bg-n-alpha-2" />
      <div class="h-6 w-20 rounded bg-n-alpha-2" />
    </div>

    <!-- Body skeleton -->
    <div class="flex flex-1 min-h-0">
      <div class="flex-1 px-6 py-6">
        <div class="max-w-3xl mx-auto space-y-4">
          <div class="h-10 w-full rounded-lg bg-n-alpha-2" />
          <div class="grid grid-cols-2 gap-4">
            <div class="h-9 rounded bg-n-alpha-2" />
            <div class="h-9 rounded bg-n-alpha-2" />
            <div class="h-9 rounded bg-n-alpha-2" />
            <div class="h-9 rounded bg-n-alpha-2" />
            <div class="h-9 rounded bg-n-alpha-2" />
            <div class="h-9 rounded bg-n-alpha-2" />
          </div>
        </div>
      </div>
      <div class="w-[280px] shrink-0 border-l border-n-weak p-4 space-y-3">
        <div class="h-32 rounded-lg bg-n-alpha-2" />
        <div class="h-20 rounded-lg bg-n-alpha-2" />
        <div class="h-16 rounded-lg bg-n-alpha-2" />
      </div>
    </div>
  </div>
</template>
